import React, { useState } from "react";
import CurrencyFormat from "react-currency-format";
import { Accordion, Segment, Label, Header, Button } from "semantic-ui-react";
import { DateTimeBadge } from "../../../../components/badges";

interface IPastPayments {
  balance: number;
  paid: number;
  id: string;
  transactions: string[];
  hideBalance?: boolean;
}

export const PastPayments = ({ transactions }: IPastPayments) => {
  const [active, setActive] = useState(false);
  const changeActive = () => {
    setActive(!active);
  };

  return (
    <Accordion fluid style={{ borderRadius: 8, backgroundColor: "#fff" }}>
      <Accordion.Title
        style={{ cursor: "pointer", display: "flex", padding: 20, alignItems: "center" }}
        active={active}
        onClick={changeActive}
      >
        <Button
          icon='dropdown'
          size='large'
          className='icon-only-button'
          aria-expanded={active}
          aria-label={`View Past Payments`}
        />
        <Header content='View Past Payments' className='tw-mt-0' />
      </Accordion.Title>
      <Accordion.Content active={active}>
        {transactions?.map((payment: any) => {
          if (payment.attributes.main_amount) {
            return (
              <>
                <Segment basic style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <div style={{ flex: "1", display: "flex", alignItems: "top", gap: 12 }}>
                      <CurrencyFormat
                        value={payment.attributes.main_amount / 100}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                        style={{ fontWeight: "bold", fontSize: 18, marginBottom: 12 }}
                      />
                      {payment.attributes.status == "pending" && (
                        <Label style={{ height: 24 }} color='teal'>
                          {" "}
                          Pending{" "}
                        </Label>
                      )}
                    </div>
                    {payment.attributes.convenience_fee_in_cents && (
                      <p className='subText'>
                        {" "}
                        {`Total charge was $${parseFloat((payment.attributes.amount / 100).toString()).toFixed(
                          2,
                        )} after convenience fee.`}{" "}
                      </p>
                    )}
                  </div>
                  <DateTimeBadge value={payment.attributes["created-at"] || payment.attributes["created_at"]} />
                </Segment>
              </>
            );
          }
        })}
      </Accordion.Content>
    </Accordion>
  );
};
